import React from 'react'
import '../../styles/about.css'
import aboutImg from '../../images/about-ergue-panfleto.jpg'
import chooseData from '../../data/chooseData.json'

const About = () => {
    return <section id="about">
        <div className="container">
            <div className="about__wrapper">
                <div className="about__content">
                    <h4 className='subtitle'> Porque escolher a Ergue</h4>
                    <h2>Especializados em </h2>
                    <h2 className="highlight"> projectos renomados e de alta qualidade</h2>
                    <p className="description about__content-description">Na ERGUE, abraçamos a inovação e comprometemo-nos com a sustentabilidade. Cada projeto é uma oportunidade para integrar design criativo com práticas ambientalmente conscientes, construindo não apenas estruturas, mas legados duradouros.</p>
                    <div className='choose__item-wrapper'>
                        {
                            chooseData.map((item, index) => (
                                <div key={index} className="choose__us-item">
                                    <span className="choose__us-icon">
                                        <i className={item.icon}></i>
                                    </span>
                                        <h4 className="choose__us-title">{item.title}</h4>
                                        <p className="description">{item.description}</p>
                                </div>
                            ))
                        }
                    </div>
                </div>

                <div className="about__img">
                    <img src={aboutImg} alt="Ergue panfleto" />
                </div>
            </div>
      </div>
  </section>
}

export default About
